"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  DATA_NATIONAL: 'data',
  SMS_ALLNET: 'minutes-sms',
  VOICE_ALLNET: 'clock',
  voice_international: 'call',
  includedApps: 'entertainment'
};
exports.default = _default;